import React from 'react'
import './HomeStructure.css'
import { useSelector } from 'react-redux'
import {translation} from "../I18n/i18n"
import BannerCarousel from '../Components/Carousel'
import { Link } from 'react-router-dom'

function HomeStructure() {

    const lang = useSelector(state => state.languageReducer.language)
    
    return (
        <div>
            <img  className='mainbanner' src='../../banner.jpg' alt=''></img>
            <div className='logotextContainer'>
                <div style={{width:'40%',display:'flex',alignItems:'center',justifyContent:'center'}}>
                        <img 
                            src='../../logoMyostarCaree.jpg'
                            alt=''
                            width='260px'
                            height='200px'
                        /></div>
                <div className='home_textContainer'>
                    <div className='text_home'>{translation(lang,"homeTextPart1")}</div>
                </div>
            </div>
            {/* <div className='second_home_zone'>
                <div className='expanding__card'>
                    <div className='expanding__card__imgBox'>
                        <img 
                            src='../../logoMyostarCaree.jpg'
                            alt=''
                            width='260px'
                            height='200px'
                        />
                    </div>
                    <div className='expanding__card__content'>
                        <h2>Musculation</h2>
                        <div className='expanding__card__content_separator'></div>
                        <p> Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
                    </div>
                </div>
                <div className='expanding__card'>
                    <div className='expanding__card__imgBox'>
                        <img 
                            src='../../logoMyostarCaree.jpg'
                            alt=''
                            width='260px'
                            height='200px'
                        />
                    </div>
                    <div className='expanding__card__content'>
                        <h2>Cardio</h2>
                        <div className='expanding__card__content_separator'></div>
                        <p> Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
                    </div>
                </div>
                <div className='expanding__card'>
                    <div className='expanding__card__imgBox'>
                        <img 
                            src='../../logoMyostarCaree.jpg'
                            alt=''
                            width='260px'
                            height='200px'
                        />
                    </div>
                    <div className='expanding__card__content'>
                        <h2>Réeducation</h2>
                        <div className='expanding__card__content_separator'></div>
                        <p> Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
                    </div>
                </div>
            </div>
            <div className='footer' style={{backgroundColor:'black',height:'400px'}}>

            </div> */}
            {/* <div className='bestsales'>
                {translation(lang,"bestSales")}
            </div> */}
            <Link to="/catalogue">
                {/* <BannerCarousel/> */}
            </Link>
            <div className='footer'>
                Okami 2021 All right reserved
            </div>   
        </div>
    )
}

export default HomeStructure
